import React, { useState } from 'react'
import { service_insurance } from '../../../data/servicesData'

const CarTabPage = () => {
    const[data] = useState(service_insurance?.car || {});
  return (
    <div className="text-left space-y-6">
        <div className="space-y-2">
        {data.overview.map((item, index) => (
          <div key={index}>
            <span>
              {item}
            </span>
          </div>
        ))}
      </div>
      <div className="space-y-2">
        <h1 className="font-bold">{data.insurance_types.description}</h1>
        <div className="ml-8">
          <ul className="list-disc space-y-1">
            {data.insurance_types.covers.map((item, index) => (
              <li key={index}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="space-y-2">
        <h1 className="font-bold">{data.third_party_types.description}</h1>
        <div className="ml-8">
          <ul className="list-disc space-y-1">
            {data.third_party_types.covers.map((item, index) => (
              <li key={index}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="space-y-2">
        <h1 className="font-bold">{data.third_party_types2.description}</h1>
        <div className="ml-8">
          <ul className="list-disc space-y-1">
            {data.third_party_types2.covers.map((item, index) => (
              <li key={index}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="space-y-2">
        <h1 className="font-bold">{data.benefits_features.description}</h1>
        <div className="ml-8">
          <ul className="list-disc space-y-1">
            {data.benefits_features.covers.map((item, index) => (
              <li key={index}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default CarTabPage